<template>
	<v-card class='speaker-sessions-page page elevation-0'>
		<v-card-text class='d-flex'>
			<v-skeleton-loader
				v-if='isLoading'
				v-bind='attrs'
				width='600'
				type='list-item, list-item-three-line, card-heading'
			>
			</v-skeleton-loader>

			<div v-else style='width: 100%'>
				<div class='speaker-sessions-page__title mb-5'>
					{{ pageTitle }} Sessions
				</div>

				<div v-for='{ date, data } in groupedByMonthAndDay' :key='date' class="mt-3">
					<div class='speaker-sessions-page__session-title'>{{ date }}</div>

					<div v-for='(agenda, index) in data' :key='index'>
						<router-link
							v-if='agenda.is_extended'
							:to="{ name: 'event-session-by-id', params: {
								eventId: agenda.events_id,
								sessionId: agenda.events_agenda_id
							} }"
							class='d-flex text-decoration-none'
							style='width: 100%;'
						>
							<SpeakerSessionCard :session="agenda" :type="type"/>
						</router-link>
						<SpeakerSessionCard v-else :session="agenda" :type="type"/>
					</div>
				</div>

				<NewsFeedEmpty
					v-if='groupedByMonthAndDay.length <= 0'
					title="Sessions not found at this moment."
					description="Check back later."
					centering="center"
				/>


				<div
					class='d-flex my-9 justify-center home-page__pagination'
					v-if='!isLoading && groupedByMonthAndDay.length > 0'
				>
					<Pagination 
                        :page="filters.page"
                        :pageCount="+speaker.metaList[type].pageCount"
                        v-on:pageChange="onPageChange"
                    />
				</div>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SpeakerSessionCard from '../../components/Event/SpeakerSessionCard.vue'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty.vue'
import Pagination from '@/components/Pagination.vue'

export default {
	name: 'SpeakerSessionsPage',
	components: {
		SpeakerSessionCard,
		NewsFeedEmpty,
		Pagination
	},
	methods: {
		...mapActions('user', ['getSpeaker', 'getSpeakerSessions']),

		onPageChange(page) {
			if (page !== this.filters.page) {
				this.filters.page = page
				this.getSpeakerSessions({ id: +this.$route.params.id, type: this.type, page})
			}
		},

		formatFilters(filters) {
			const { page } = filters

			return `&event_id=${this.$route.params.id}&page=${page}`
		},
	},

	created() {
		const speaker = this.speaker
		const id = +this.$route.params.id
		const type = this.$route.params.type
		if (!speaker || (speaker && !speaker.sessions[type] && speaker.speaker_id !== id) || speaker.metaList[type].currentPage > 1) {
			this.getSpeakerSessions({ id, type })
		}
	},

	computed: {
		...mapGetters('user', ['speaker', 'isLoading']),

		groupedByMonthAndDay() {
			if (!this.sessions) {
				return [];
			}

			return Object.values(
				this.sessions.reduce((prev, current) => {
					const fromDate = new Date(current.events_agenda_from * 1000)

					const month = fromDate.toLocaleString('en-US', { month: 'long' })
					const year = fromDate.getFullYear()
					const day = fromDate.getDate()
					const key = `${month} ${day}, ${year}`

					if (!prev[key]) {
						prev[key] = {
							date: key,
							data: [],
						}
					}

					prev[key].data.push(current)

					return prev
				}, {}),
			).map((item) => {
				const { data } = item

				return {
					...item, data: data.sort((a, b) => {
						const { events_agenda_from: aEventsFrom } = a
						const { events_agenda_from: bEventsFrom } = b

						return aEventsFrom - bEventsFrom
					}),
				}
			})
		},

		sessions() {
			if (!this.speaker) {
				return []
			}

			return this.speaker.sessions ? this.speaker.sessions[this.$route.params.type] : []
		},
		type() {
			return this.$route.params.type
		},
		pageTitle() {
			return this.type === 'future' ? 'Active' : 'Past'
		},
	},

	data() {
		return {
			attrs: {
				elevation: 0,
			},
			filters: {
				page: 1,
			}
		}
	},
}
</script>

<style lang='scss'>
.speaker-sessions-page {
	background: #f1f1f1 !important;
	font-family: Montserrat, sans-serif;

	&__title {
		font-size: 24px;
		font-weight: 700;
		color: var(--accent-color);
		line-height: 29.3px;
		text-transform: capitalize;
	}

	&__session {
		&-title {
			font-size: 16px;
			font-weight: 600;
			color: var(--accent-color);
			line-height: 19.5px;
			margin-bottom: 16px;
		}
	}
}

@media screen and (min-width: 1200px) {
	.speaker-sessions-page {
		max-width: 100%;
		width: 100%;
	}
}

@media screen and (min-width: 1320px) {
	.agenda-page-container {
		max-width: 600px;
	}
}
</style>
